import { render, staticRenderFns } from "./reconocimiento.vue?vue&type=template&id=c7e20ca4&"
import script from "./reconocimiento.vue?vue&type=script&lang=js&"
export * from "./reconocimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports